import AddressDropdownView from '~/shared/components/AddressDropdown';
import {AddressDropdownContext} from '~/shared/components/AddressDropdown/context';
import useAddressDropdownContextValue from '~/common/hooks/useAddressDropdownContextValue';
import {GoogleMapsAPIProvider} from '~/shared/components/Maps';

const AddressDropdown = ({onOpen, isMenuPage}: {
  onOpen?: () => void;
  isMenuPage: boolean;
}) => {
  const addressDropdownContextValue = useAddressDropdownContextValue({onOpen, isMenuPage});

  return (
    <AddressDropdownContext.Provider
      value={addressDropdownContextValue}
    >
      <GoogleMapsAPIProvider>
        <AddressDropdownView />
      </GoogleMapsAPIProvider>
    </AddressDropdownContext.Provider>
  );
};

export default AddressDropdown;
